{
  "header": "Your agent has updated your purchase / booking information.",
  "uplift": {
    "subheader": "Your agent will send you a new application link to proceed with Uplift."
  },
  "flexpay": {
    "subheader": "Your agent will send you a new application link to proceed with Flex Pay."
  },
  "didNotRequest": "If you did not request any changes to your purchase / booking or personal information, please ask your agent."
}
